import { useModalSize, type ModalSize } from '@/hooks/screen';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@heroui/react';
import type { ReactNode } from 'react';

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  size?: ModalSize;
}

export function ModalWrapper({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size,
}: ModalWrapperProps) {
  const modalSize = useModalSize() || size || '2xl';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={modalSize}
      scrollBehavior='inside'
      placement='center'
    >
      <ModalContent>
        <ModalHeader className='text-xl font-semibold'>{title}</ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>{footer}</ModalFooter>
      </ModalContent>
    </Modal>
  );
}
